/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrOrgRequester } from './edrOrgRequester';


export interface EdrOrgDetails { 
    /**
     * The organization ID for the EDR service.
     */
    edr_org_id: string;
    /**
     * The numeric Carbon Black organization identifier (CBC org_id). Populated only for Carbon Black on-premises orgs; null for CrowdStrike.
     */
    edr_cb_org_id?: number;
    /**
     * The region for the EDR cloud instance.
     */
    edr_region: string;
    /**
     * The API endpoint URL for the EDR service.
     */
    edr_endpoint: string;
    edr_requester?: EdrOrgRequester;
}

